import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AccessTracker } from './components/AccessTracker';
import { AsignacionEntranteBanner } from './components/AsignacionEntranteBanner';
import AppRouter from './router/AppRouter';
import './styles/variables.css';
import './styles/global.css';

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <AccessTracker />
            {/* Montado UNA vez fuera del árbol de rutas — no se desmonta al
                navegar, para que el timbre/listener de asignación persista
                sin importar en qué página esté el médico. */}
            <AsignacionEntranteBanner />
            <AppRouter />
            {/* EnvironmentBadge se muestra en la barra superior del MainLayout
                (antes flotaba abajo-derecha y tapaba botones de acción) */}
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
